import { environment } from '../../../environments/environment';
// export const baseURL = 'https://dev.everything.insure/v1/';
export const baseURL = environment.baseURL; // 'https://uat.everything.insure/v1/';

export const emailRegex =
  /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const mobileRegex = /^(\+\d{1,3}[- ]?)?\d{10}$/;


export enum   RouterLinks {
  CreatePassword = 'create-password',
  SignUp = 'sign-up',
  SignUpEmail = 'sign-up-email',
  Login = 'login',
  LoginVerification = 'login-verification',
  ForgotPassword = 'forgot-password',
  ForgotPasswordLink = 'forgot-password-link',
  ResetPassword = 'reset-password',
  UnderwriterLanding = 'everything.underwriter-landing',
  DashboardLanding = 'everything.dashboard',
  ScoreDashboard = 'score-dashboard',
  BrokerDashboard = 'broker-dashboard',
  PolicyInsuredItemEdit = 'everything.policy-insured-item-edit',
  UnderwriterPolicyCondition = 'underwriters.policy-condition',
  UnderwriterPolicyConditionClasses = 'underwriters.policy-condition-classes',
  UnderwriterPolicyConditionInfoRequested = 'underwriters.policy-condition-info-requested',
  UnderwriterPolicyViewTranscript = 'underwriters.policy-view-transcript',
  PoliciesLanding = 'everything.policies-landing',
  MembershipLanding = 'membership-landing',
  MembershipOverview = 'membership-overview',
  PolicyWording = 'everything.policy-wording',
  PolicySchedule = 'everything.policy-schedule',
  PolicyPDFSchedule = 'everything.policy-pdf-schedule',
  QuoteComparePdf = 'everything.quote-compare-pdf',
  PolicyQuoteSchedule = 'everything.policy-quote',
  PolicyTranscript = 'policy-transcript',
  PolicyStatement = 'policy-statement',
  TaxInvoice = 'tax-invoice',
  PolicyStatementiFrame = 'policy-statement-iframe',
  PolicySummary = 'policy-summary',
  PolicyPayment = 'policy-payment',
  MembershipTranscript = 'membership-transcript',
  PolicyHolders = 'everything.policy-holders',
  GlobalSearch = 'global-search',
  ComplianceVault = 'compliance-vault',
  BrokerResources = 'broker-resources',
  PolicyUnderwriters = 'everything.policy-underwriters',
  PolicyOverviewEdit = 'everything.policy-overview-edit',
  PolicyOverview = 'everything.policy-overview',
  PolicyInsuredItems = 'everything.policy-insured-items',
  MembershipInsuredItems = 'membership-insured-items',
  PolicyInsuredItemsDetail = 'everything.policy-insured-items-detail',
  PolicyAddons = 'everything.policy-addons',
  MembershipAddons = 'membership-addons',
  PolicyResources = 'everything.policy-resources',
  PolicyCertificateOfCover = 'everything.policy-certificate-of-cover',
  MembershipResources = 'membership-resources',
  PolicyPostDetailRequired = 'policy-post-signup-details-required',
  PolicyPostDetail = 'policy-post-signup-detail',
  PolicyEdit = 'policy-edit',
  PolicyEditSummary = 'policy-edit-summary',
  ClaimsLanding = 'everything.claims-landing',
  QuoteLanding = 'quote-landing',
  QuoteRenewal = 'quote-renewal',
  QuoteRenewalEdit = 'quote-renewal-edit',
  QuoteRenewalCompare = 'quote-renewal-compare',
  QuoteRenewalSummary = 'quote-renewal-summary',
  QuoteChangeProduct = 'quote-change-product',
  QuoteChangeBenefits = 'quote-change-benefits',
  QuoteQuestions = 'quote-questions',
  QuoteWizard = 'quote-wizard',
  QuotePickCover = 'quote-pick-cover',
  QuoteConfirmCover = 'quote-confirm-cover',
  QuoteConfirmCoverChanges = 'quote-confirm-cover-changes',
  QuoteConfirmCoverChangesFailEdit = 'quote-confirm-cover-changes-fail-edit',
  QuoteCustomizeCover = 'quote-customize-cover',
  QuotePayCover = 'quote-pay-cover',
  QuoteUnderwriting = 'quote-underwriting',
  QuoteCovered = 'quote-covered',
  ProcessClaim = 'everything-process-claim',
  ClaimPledge = 'everything.claims-pledge',
  EmergencyAssistProductSelect = 'everything.emergency-assist-product-select',
  EmergencyAssistLocation = 'everything.emergency-assist-location',
  EmergencyAssistLocateMe = 'everything.emergency-assist-locate-me',
  EmergencyAssistAssistCode = 'everything.emergency-assist-code',
  EmergencyAssistCancelProduct = 'everything.emergency-assist-cancel-product',
  ClaimEventDetailsSelectCategory = 'everything.claims-eventdetails-select-category',
  ClaimEventDetailsSelectClasses = 'everything.claims-eventdetails-select-classes',
  ClaimEventDetailsSelectEvent = 'everything.claims-event-details-select-event',
  ClaimEventDetailsName = 'everything.claims-event-details-name',
  ClaimEventDetailsLocation = 'everything.claims-event-details-location',
  ClaimEventDetailsLocationLocateMe = 'everything.claims-event-details-location-locate-me',
  ClaimEventDetailsDescription = 'everything.claims-event-details-description',
  ClaimEventDetailsSelectDate = 'everything.claims-event-details-select-date',
  ClaimEventDetailsSelectTime = 'everything.claims-event-details-select-time',
  ClaimWitnesses = 'everything.claims-witnesses',
  ClaimEventDetailsWitnessDetails = 'everything.claims-event-details-witnessdetails',
  ClaimSelectItemOrBenefitInterstitialVehicle = 'everything.claims-select-item-benefit-interstitial-vehicle',
  ClaimSelectItemOrBenefitSelectVehicles = 'everything.claims-select-item-benefit-select-vehicles',
  ClaimSelectItemOrBenefitSelectBenefit = 'everything.claims-select-item-benefit-select-benefit',
  ClaimSelectItemOrBenefitSelectVehicleBenefits = 'everything.claims-select-item-benefit-select-vehicles-benefits',
  ClaimSelectItemOrBenefitDetailsInterstitial = 'everything.claims-select-item-benefit-details-interstitial',
  ClaimSelectItemOrBenefitDetailsInterstitialVehicle = 'everything.claims-select-item-benefit-details-intersitial-vehicle',
  ClaimSelectItemOrBenefitDetailsDriver = 'everything.claims-select-item-benefit-details-driver',
  ClaimSelectItemOrBenefitDetailsDriverDetails = 'everything.claims-select-item-benefit-details-driver-details',
  ClaimSelectItemOrBenefitDetailsOdometerReading = 'everything.claims-select-item-benefit-details-odometer-reading',
  ClaimSelectItemOrBenefitDetailsVehiclesInvolved = 'everything.claims-select-item-benefit-details-vehicles-involved',
  ClaimSelectItemOrBenefitDetailsImagesOfDamage = 'everything.claims-select-item-benefit-details-images-of-damage',
  ClaimSelectItemOrBenefitInterstialNoneVehicle = 'everything.claims-select-item-or-benefit-interstitial-nonvehicle',
  ClaimSelectItemOrBenefitSelectBuildings = 'everything.claims-select-item-or-benefit-select-buildings',
  ClaimSelectItemOrBenefitSelectContents = 'everything.claims-select-item-or-benefit-select-contents',
  ClaimSelectItemOrBenefitContentBenefits = 'everything.claims-select-item-or-benefit-content-benefits',
  ClaimSelectItemOrBenefitPersonalItemSpecified = 'everything.claims-select-item-or-benefit-nonvehicle-personalitem-specified',
  ClaimSelectItemOrBenefitPersonalItemUnspecified = 'everything.claims-select-item-or-benefit-nonvehicle-personalitem-unspecified',
  ClaimSelectItemOrBenefitPersonalItemBenefit = 'everything.claims-select-item-or-benefit-nonvehicle-personalitem-benefit',
  ClaimSelectItemOrBenefitPolicyBenefit = 'everything.claims-select-item-or-benefit-nonvehicle-policy-benefit',
  DocsBrokerAppointmentLetter = 'everything.docs-broker-apppointment-letter',
  DocsDebitOrderAuthority = 'everything.docs-debit-order-auth',
  DocsPolicyStatement = 'everything.docs-policy-statement',
  DocsTaxInvoice = 'everything.docs-tax-invoice',
  DocsCookiesPolicy = 'everything.docs-cookies-policy',
  DocsPrivacyPolicy = 'everything.docs-privacy-policy',
  DocsProfessionalFeeAgreement = 'everything.docs-professional-fee-agreement',
  ClaimSummary = 'claims-summary',
  ClaimSummaryUpdate = 'claims-summary-update',
  ClaimSummaryItemEdit = 'claims-summary-item-edit',
  DocsTermsAndCondition = 'everything.docs-terms-and-conditions',
  DocDocument = 'doc-document',
  QuestionFlow = 'question-flow',
  DealAlert = 'deal-alert',
  QuoteUWPage = 'quote-uw-page',
  AddBenefits = 'add-benefits',
  QuoteUWPageUnpayable = 'quote-uw-page-unpayable',
  QuoteUWPageSubmitted = 'quote-uw-page-submitted',
  ClaimEdit = 'claim-edit',
  PolicyConfirmationOfCover = 'confirmation-cover',
  CheckToken = 'check-token',
  EditProfile = 'edit-profile',
  CommercialEdit = "commercial-edit",
  CommercialAddLocation = "commercial-add-location",
  ClaimTranscript = "claim-transcript",
  Documents = 'documents',
  DocumentsGeneral = 'documents-general',
  PolicyDocuments = 'policy-documents',
  PolicyVersion = 'policy-version',
  QuoteOutstanding = 'quote-outstanding',
  NotificationsLanding = 'notifications',

  /*Account Routes*/
  Account = 'account',
  NotificationSettings = 'notification-settings',
  PaymentDetails = 'payment-details',
  ChangePassword = 'change-password',
  Referrals = 'referrals',
  Wallet = 'wallet',
  AccountEdit = 'account-edit'
  
  
}

export enum PolicyScheduleHeaders {
  PolicyHolderDetails = 'Policy Holder Details',
  PolicyDetails = 'Policy Details',
  BrokerDetails = 'Broker Details',
  InsurerDetails = 'Insurer Details',
  NoteToPolicyHolder = 'Note to Policy Holder',
}

export enum PolicyScheduleDisclosureNotice {
  ALWAYS_ON_TOP = 'ALWAYS ON TOP',
  PARTICULARS_OF_YOUR_INSURER = 'PARTICULARS OF YOUR INSURER',
  PARTICULARS_OF_YOUR_UNDERWRITING_MANAGER = 'PARTICULARS OF YOUR UNDERWRITING MANAGER',
  PARTICULARS_OF_YOUR_BINDER_HOLDER = 'PARTICULARS OF YOUR BINDER HOLDER',
  PARTICULARS_OF_YOUR_SERVICE_PROVIDER = 'PARTICULARS OF YOUR SERVICE PROVIDER',
  PARTICULARS_OF_YOUR_OMBUDSMAN = 'Particulars of your Ombudsman',
  PARTICULARS_OF_SASRIA = 'PARTICULARS OF SASRIA',
  ALWAYS_ON_BOTTOM = 'ALWAYS ON BOTTOM',
}

export enum PolicyPDFScheduleDisclosureNotice {
  ALWAYS_ON_TOP = 'ALWAYS ON TOP',
  PARTICULARS_OF_YOUR_INSURER = 'PARTICULARS OF YOUR INSURER',
  PARTICULARS_OF_YOUR_UNDERWRITING_MANAGER = 'PARTICULARS OF YOUR UNDERWRITING MANAGER',
  PARTICULARS_OF_YOUR_BINDER_HOLDER = 'PARTICULARS OF YOUR BINDER HOLDER',
  PARTICULARS_OF_YOUR_SERVICE_PROVIDER = 'PARTICULARS OF YOUR SERVICE PROVIDER',
  PARTICULARS_OF_YOUR_OMBUDSMAN = 'Particulars of your Ombudsman',
  PARTICULARS_OF_SASRIA = 'PARTICULARS OF SASRIA',
  ALWAYS_ON_BOTTOM = 'ALWAYS ON BOTTOM',
}

export const API_PATH = {
  CREATE_PASSWORD: `${baseURL}${RouterLinks.CreatePassword}`,
  SIGN_UP: `${baseURL}${RouterLinks.SignUp}`,
  SIGN_UP_EMAIL: `${baseURL}${RouterLinks.SignUpEmail}`,
  LOGIN: `${baseURL}${RouterLinks.Login}`,
  REFRESH_TOKEN: `${baseURL}refresh-token`,
  SEND_SMS: `${baseURL}send-sms`,
  SEND_OTP: `${baseURL}send-otp`,
  VALIDATE_OTP: `${baseURL}validate-otp`,
  LOGIN_VERIFY_OTP: `${baseURL}login/verify-otp`,
  LOGIN_VERIFICATION: `${baseURL}${RouterLinks.LoginVerification}`,
  RESEND_CODE: `${baseURL}resend-code`,
  FORGOT_PASSWORD: `${baseURL}forgot-password`,
  RESET_PASSWORD: `${baseURL}reset-password`,
  POLICIES: `${baseURL}get-policies`,
  POLICIY_WORDING: `${baseURL}get-policy-wording`,
  POLICIY_SCHEDULE: `${baseURL}get-policy-schedule`,
  BROKER_UW_LANDING: `${baseURL}get-uw-policy-landing-data`,
  CANCEL_POLICY: `${baseURL}cancel-policy`,
  GET_QUESTION_GROUPING: `${baseURL}get-question-grouping`,
  SAVE_PROFILE: `${baseURL}save-profile`,
  GET_POLICY_DATA: `${baseURL}get-followup-data`,
  EDIT_POLICY: `${baseURL}edit-policy`,
  UPDATE_POLICY: `${baseURL}update-policy`,
  SAVE_ANSWER: `${baseURL}save-answer`,
  REMOVE_ANSWER: `${baseURL}remove-answer`,
  GET_ANSWERS_FILTERS: `${baseURL}get-answers-filter`,
  GET_INSURER_RATING: `${baseURL}get-insurer-rating`,
  GET_AGE_LICENSE_YEARS: `${baseURL}get-age-license-years`,
  GET_VAP_QUESTIONS: `${baseURL}get-vap-questions`,
  GET_QUOTE_LINKS: `${baseURL}get-quote-links`,
  GET_QUOTES: `${baseURL}get-quotes`,
  GET_VAP_PREMIUM: `${baseURL}get-vap-premium`,
  CALC_PREM_DIFF: `${baseURL}calc-prem-diff`,
  COLLATE_ADDONS: `${baseURL}collate-addons`,
  CHECK_POLICY_CHANGES: `${baseURL}check-policy-changes`,
  SAVE_POLICY_UPDATE: `${baseURL}save-policy-update`,
  REMOVE_POLICY_UPDATE: `${baseURL}remove-policy-update`,
  SUBMIT_POLICY_UPDATES: `${baseURL}submit-policy-updates`,
  SAVE_POLICY_VAPS_UPDATE: `${baseURL}save-policy-vaps-update`,
  REMOVE_POLICY_VAPS_UPDATE: `${baseURL}remove-policy-vaps-update`,
  GET_SUMMARY_OF_CHANGES: `${baseURL}get-summary-of-changes`,
  GET_DOCUMENT: `${baseURL}get-document`,
  GET_DOCUMENTS: `${baseURL}get-documents`,
  UW_GET_WORDING_LIST: `${baseURL}get-wording-list`,
  UW_GET_WORDING_HISTORY: `${baseURL}get-wording-history`,
  UW_ADD_WORDING: `${baseURL}add-wording`,
  UW_REMOVE_WORDING: `${baseURL}remove-wording`,
  UW_GET_NOTES: `${baseURL}get-notes`,
  UW_ADD_NOTE: `${baseURL}add-note`,
  UW_UPDATE_NOTE: `${baseURL}update-note`,
  UW_REMOVE_NOTE: `${baseURL}remove-note`,
  UW_UPDATE_ANSWER: `${baseURL}update-answer`,
  UW_ANSWER_HISTORY: `${baseURL}get-answer-history`,
  UW_REJECT_POLICY: `${baseURL}reject-policy`,
  UW_UPDATE_PREMIUM: `${baseURL}update-premium`,
  UW_SAVE_CONDITION: `${baseURL}save-uw-condition-update`,
  GET_CATEGORIES: `${baseURL}get-everything-categories`,
  GET_CLASSES: `${baseURL}get-everything-classes`,
  GET_CLAIMSDATA: `${baseURL}get-everything-claimdata`,
  GET_FLOW_QUESTIONS: `${baseURL}get-everything-flow-questions`,
  CREATE_UPDATE_CLAIM: `${baseURL}create-update-claim`,
  CREATE_CLAIM: `${baseURL}create-claim`,
  GET_NEXT_QUESTION: `${baseURL}get-next-question`,
  GET_NEXT_PAGE: `${baseURL}get-next-page`,
  GET_NEXT_QUESTION2: `${baseURL}get-next-question-2`,
  CLAIMS: `${baseURL}get-claims`,
  RUN_COMMAND: `${baseURL}run-command`,
  RUN_NEW_COMMAND: `${baseURL}run-new-command`,
  RUN_COMMAND_MULTIPLE_DATASETS: `${baseURL}run-command-multiple-datasets`,
  CREATE_QUOTE: `${baseURL}create-quote`,
  UPDATE_QUOTE: `${baseURL}update-quote`,
  GET_TRANSCRIPT: `${baseURL}get-transcript`,
  GET_SHOPPINGCART: `${baseURL}get-shopping-cart`,
  GET_SHOPPINGCARTQCAP: `${baseURL}get-shopping-cart-qcap`,
  GET_NEXTFLOW: `${baseURL}get-next-flow`,
  GET_NEXT_SUPERFLOW: `${baseURL}get-next-superflow`,
  SAVE_ANSWERS: `${baseURL}save-answers`,
  GET_FLOWS: `${baseURL}get-flows`,
  GET_FLOW_ITEMS: `${baseURL}get-flow-items`,
  SAVE_FLOW_HISTORY: `${baseURL}save-flow-history`,
  GET_PREVIOUS: `${baseURL}get-previous`,
  UPLOAD_RESOURCE: `${baseURL}resource`,
  DELETE_RESOURCE: `${baseURL}resource`,
  INDIA_PROVINCES: `${baseURL}resource/india-provinces`,
  GET_RESOURCE_DETAILS: `${baseURL}details`,
  GET_DASHBOARD_DATA: `${baseURL}get-dashboard-data`,
  VALIDATE_BANK_ACCOUNT: `${baseURL}validate-bank-account`,
  EVI_UPLOAD_STATUS: `${baseURL}evi-upload-status`,
};

export enum NavbarType {
  LoggedIn,
  LoggedOut,
  PolicyWording,
  PolicySchedule,
  PolicyQuoteSchedule,
  PolicyTranscript,
  PolicyUnderwriters,
  PolicyOverviewEdit,
  BrokerUnderwriterLanding,
  BrokerUnderwriterCondition,
  PolicyEdit,
  PolicyEditSummary,
  QuoteQuestions,
  QuoteWizard,
  QuestionFlow,
  Claim,
  ClaimTranscript,
  EmergencyAssist,
  EmergencyAssistCancel,
  Documentation,
  CertificateOfCover,
  ClaimSummary,
  ClaimSummaryUpdate,
  ClaimSummaryItemEdit,
  QuotePickCover,
  QuoteConfirmCover,
  QuoteConfirmCoverChanges,
  QuoteCustomizeCover,
  QuotePayCover,
  QuoteUnderwriting,
  QuoteCovered,
  DealAlert,
  QuoteUWPage,
  QuoteUWUnpayablePage,
  QuoteUWSubmittedPage,
  MembershipTranscript,
  AccountEdit,
  ClaimEdit,
  ComplianceVault,
  EditProfile,
  QuoteOutstanding
}

export enum VapsStatus {
  Active = 'active',
  Paused = 'paused',
  Cancelled = 'cancelled',
}

export enum QuestionType {
  default = 1,
  textbox = 2,
  textbox_readonly = 180,
  address = 3,
  plus_minus = 4,
  autocomplete = 5,
  checkbox = 6,
  radio = 7,
  currency = 8,
  analysis = 9,
  quote_page = 10,
  pay_page = 11,
  exception = 12,
  profession = 13,
  list = 14,
  vehicle = 15,
  household = 16,
  structure = 17,
  contents = 18,
  dropdown = 19,
  dropdown_currency = 201,
  date = 20,
  date_readonly = 103,
  time = 21,
  time_readonly = 184,
  upload = 22,
  textarea = 23,
  submit = 24,
  image_multiple = 25,
  claim_form = 26,
  claim_edit_page = 216,
  claim_history_motor = 27,
  claim_history_household = 28,
  claim_history_allrisk = 29,
  claim_tracker = 30,
  industry = 31,
  summary = 32,
  id_number = 33,
  registration_number = 34,
  family_list = 35,
  number = 36,
  number_readonly = 182,
  allrisk_list = 37,
  checkbox_image = 38,
  select_button = 39,
  scope = 40,
  database_list = 41,
  agree = 42,
  other_id_number = 43,
  sub_profession = 44,
  toggle = 46,
  passport = 47,
  radio_image = 48,
  radio_icon = 185,
  multiselect = 49,
  dob = 50,
  email = 51,
  tel = 52,
  popup = 53,
  addon = 54,
  vehicle_list = 55,
  secondary_contact = 56,
  vaps_location_1 = 57, // Locations,Textbox (numbers) (Buildings)
  vaps_location_2 = 58, // Locations,Textbox (currency) (Buildings)
  vaps_vehicle_1 = 59, // Vehicles,Textbox (%)
  vaps_vehicle_2 = 60, // Vehicles,Textbox (alpha),Textbox (alpha)
  vaps_vehicle_3 = 61, // Vehicles,Dropdown
  vaps_vehicle_4 = 62, // Vehicles,Dropdown,Textbox (numbers)
  vaps_general_1 = 63, // Textbox (numbers),Textbox (currency)
  vaps_general_2 = 64, // Textbox (%)
  vaps_general_3 = 65, // Textbox (currency)
  vaps_general_4 = 66, // Textbox (alpha)
  vaps_general_5 = 67, // Textbox (alpha),Textbox (alpha)
  vaps_general_6 = 68, // Textbox (alpha),Textbox (alpha),Textbox (currency)
  vaps_general_7 = 69, // Dropdown,Textbox (currency)
  vaps_general_8 = 70, // Dropdown
  vaps_location_3_buildings = 71, // Locations (Buildings)
  vaps_vehicle_5 = 72, // Vehicles
  vehicle_make = 73,
  vehicle_model = 74,
  vehicle_year = 75,
  vaps_location_3_contents = 76, // Locations,Textbox (currency) - Contents
  addons = 77,
  slider_si = 78,
  slider_excess = 79,
  rebuild_cost = 80,
  vaps_location_4 = 81, // Locations,Textbox (numbers) (Contents)
  vaps_location_5 = 82, // Locations,Textbox (currency) (Contents)
  vaps_location_6 = 83, // Locations (Contents)
  vaps_general_9 = 84, // Textbox (alpha), Textbox (alpha), Dropdown, Textbox (Currency)
  vaps_general_10 = 85, // Textbox (alpha), Textbox (Currency)
  vaps_general_11 = 86, // Textbox (alpha), Textbox (alpha), Textbox (number), Textbox (Currency)
  insurer = 87,
  stepper = 88,
  year = 89,
  vaps_funeral_1 = 90,  // Person
  vaps_funeral_2 = 91,  // Person,Textbox(currency)
  redirect_to_url = 94,
  vaps_funeral_3 = 200,  // Person,Textbox(currency)
  cover = 92,  // cover
  toggle_parent = 99,
  label_perc = 101,
  label_amount = 102,
  textbox_perc = 103,
  textbox_amount = 104,
  label_amount_parent = 105,
  label_perc_parent = 106,
  textbox_perc_parent = 107,
  textbox_amount_parent = 108,
  radio_list = 109,
  radio_column_parent = 110,
  radio_column = 111,
  product_select = 164,
  interstitial_variation_one = 125,
  interstitial_variation_two = 144,
  pledge = 122,
  witness_details = 142,
  multiselect_items = 128,
  claim_security_code = 166,
  multi_select_grouped = 161,
  odometer_reading = 157,
  vehicle_damage_images = 165,
  items_specify = 167,
  parent_question_variation_one = 146,
  parent_question_variation_two = 117,
  uploader_variation_one = 145,
  pills = 169,
  claim_summary = 162,
  claim_summary_update = 163,
  location = 170,
  verify_email = 114,
  cover_page = 171,
  addons_page = 172,
  uw_page = 173,
  selector = 175,
  policy_edit = 176,
  edit_modal = 177,
  policy_quote = 178,
  currency_readonly = 181,
  upload_all_media = 186,
  upload_images = 187,
  upload_videos = 188,
  upload_selfie = 189,
  upload_documents = 190,
  textbox_percentage = 192,
  start_end_date = 193,
  mini_flow = 194,
  location_add_edit = 195,
  vehicle_details = 196,
  claim_confirmation = 197,
  claim_dashboard_page = 198,
  generic_miniflow_parent = 199,
  or_control = 203,
  vaps_mini_flow_player = 204,
  vaps_generic_miniflow_parent = 205,
  yay_covered_page = 206,
  checkbox_slider = 207,
  autocomplete_generic = 209,
  summary_nocalc = 210,
  interstitial_generic = 211,
  generic_parent = 212,
  label_amount_json = 213,
  label_percent_json = 214,
  traffic_cop = 215,
  yes_no = 217,
  broker_landing_page = 218,
  flow_ending_page = 219,
  super_traffic_cop = 220,
  generic_parent_stacked = 221,
  traffic_cop_2 = 224,
  renewal_edit_page = 225,
  mini_form = 226,
  checkbox_miniform = 227,
  slider_generic = 228,
  super_vaps_control = 229,
  edit_modal_2 = 230,
  multi_dropdown_perc = 234,
  funeral_policy_member = 235,
  industry_occupation = 236,
  reg_vin = 238,
  min_max_textbox = 239,
  address_textbox = 240,
  quote_loader = 243,
  quote_screen = 244,
  checkbox_search_list = 245,
  quote_pay = 246,
  radio_form = 248,
  mini_flow_sidesheet = 249,
  uw_modal = 250,
  csv_upload = 251,
  sample_new_type = 9000
}

export enum Superflow {
  business = 1,
  professional = 2,
  personal = 3,
  funeral = 4,
  personal_claim = 5,
  general_claim = 15,
}

export enum Flow {
  Claim_Emergency = 13,
  Claim_General = 14,
}

export enum ModalTypes {
  none = 0,
  event_details = 1,
  item_details = 2,
  police_report_details = 3,
}

export enum Classes {
  fire = 1,
  office_content = 2,
  business_interruption = 3,
  theft = 4,
  money = 5,
  goods_in_transit = 6,
  business_all_risk = 7,
  public_liability = 8,
  electronic_equipment = 9,
  vehicle = 10,
  professional_indemnity = 11,
  management_liability = 12,
  commercial_liability = 13,
  content = 14,
  personal_item = 15,
  building = 18,
  home = 20,
  personal_accident = 21,
  personal_liability = 22,
  personal_legal_cost = 23,
  watercraft = 24,
  funeral = 25,
  SATIB24 = 26,
}

export enum ClassNames {
  fire = 'fire',
  office_content = 'office-contents',
  business_interruption = 'business-interruption',
  theft = 'theft',
  money = 'money',
  goods_in_transit = 'goods-in-transit',
  business_all_risk = 'business-all-risks',
  public_liability = 'public-liability',
  electronic_equipment = 'electronic-equipment',
  vehicle = 'vehicle',
  professional_indemnity = 'professional-indemnity',
  management_liability = 'management-liability',
  commercial_liability = 'commercial-liability',
  content = 'contents',
  personal_item = 'personal-items',
  building = 'building',
  home = 'home',
  personal_accident = 'personal-accident',
  personal_liability = 'personal-liability',
  personal_legal_cost = 'personal-legal-costs',
  watercraft = 'watercraft',
  funeral = 'funeral',
  SATIB24 = 'SATIB24',
}

export enum CartTypes {
  claim = 'claim',
  acquisition = 'acquisition',
}

export enum EntryType {
  premium = 'premium',
  product_selected = 'product_selected',
  fees = 'fees',
  sasria_subtotal = 'sasria_subtotal',
  taxes = 'taxes',
  class_total = 'class_total',
  item = 'item',
  addon = 'addon',
  event_details = 'event_details',
  class_item = 'class_item',
  police_report_details = 'police_report_details',
  premium_prorata = 'premium_prorata',
  premium_quarter_prorata = 'premium_quarter_prorata',
  premium_annual_prorata = 'premium_annual_prorata',
  header_logo = 'header_logo',
  quote_stage = 'quote_stage',
  greeting = 'greeting',
  avatar = 'avatar',
  header = 'header',
  sub_header = 'sub_header',
  yay_header = 'yay_header',
  yay_body = 'yay_body',
  yay_marketing = 'yay_marketing',
  right_about = 'right_about',
  right_terms = 'right_terms',
  right_privacy = 'right_privacy',
  right_help = 'right_help',
  left = 'left',
  body = 'body',
  call_us = 'call_us',
}

export enum SectionType {
  header = 'header',
  welcome = 'welcome',
  add_item = 'add_item',
  body = 'body',
  footer = 'footer',
  help = 'help',
}
